var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.376 6.2707C11.376 6.32787 11.3644 6.38452 11.3422 6.43819C11.2979 6.54494 11.2127 6.63011 11.1059 6.67502C11.0523 6.69719 10.9957 6.70877 10.9385 6.70877H8.51535C8.27385 6.70877 8.07785 6.51277 8.07785 6.27127C8.07785 6.02977 8.27385 5.83377 8.51535 5.83377H9.8821L6.37452 2.32623C6.31735 2.26906 6.22519 2.26906 6.16802 2.32623L4.65951 3.83469C4.2611 4.23311 3.61419 4.23311 3.21577 3.83469L0.128188 0.747125C-0.0427292 0.576208 -0.0427292 0.299104 0.128188 0.128188C0.299104 -0.0427292 0.57619 -0.0427292 0.747107 0.128188L3.83469 3.21575C3.89186 3.27292 3.98402 3.27292 4.04118 3.21575L5.54968 1.70729C5.9481 1.30887 6.59502 1.30887 6.99344 1.70729L10.501 5.21484V3.84808C10.501 3.60658 10.697 3.41058 10.9385 3.41058C11.18 3.41058 11.376 3.60658 11.376 3.84808V6.2707Z",
    fill: "#E2464A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRed);
export default __webpack_public_path__ + "static/media/arrow-down-red.9555c2145271873013210195a3b9352f.svg";
export { ForwardRef as ReactComponent };